import { render, staticRenderFns } from "./CollapseTransitions.vue?vue&type=template&id=5f0c5454&scoped=true"
import script from "./CollapseTransitions.vue?vue&type=script&lang=js"
export * from "./CollapseTransitions.vue?vue&type=script&lang=js"
import style0 from "./CollapseTransitions.vue?vue&type=style&index=0&id=5f0c5454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0c5454",
  null
  
)

export default component.exports